export const apiBaseURL = process.env.REACT_APP_DWD_API_BASE_URL;
// export const apiBaseURL = "http://192.168.55.91:5000";
export const apiUAE_MT_URL = process.env.REACT_APP_DWD_API_UAE_MT_URL;
export const COMING_SOON = 'Coming Soon !!,Feature not yet developed.';
//ROUTE CONSTANTS
export const NEW_DAILOG = '/';
export const WORKSAPCE = '/dashboard';
export const SAVED_CHATS = '/savedchats';
export const SETTINGS = '/settings';
export const USAGE = '/usage';
export const OLD_DAILOG = '/oldchat';

//POC URLS
export const PBIReport_URL = '/pbireport';
export const PBIReport_URL_Dashboard = PBIReport_URL + '/dashboard';
export const PBIReport_URL_AIInsights = PBIReport_URL + '/aiinsights';
export const PBIReport_URL_AskQuestion = PBIReport_URL + '/askquestion';
export const PBIReport_URL_ReportFinder = PBIReport_URL + '/reportFinder';
export const PBIReport_URL_UserTraining = PBIReport_URL + '/userTraining';
export const PBIReport_URL_Accelerator = PBIReport_URL + '/aiAaccelerator';
export const PBIReport_URL_Feedback = PBIReport_URL + '/feedback';
export const PBIReport_URL_Login = PBIReport_URL + '/login';

//API END POINTS

export enum BUTTON_TYPES {
  TYPE_1 = 'type_1',
  TYPE_2 = 'type_2',
  TYPE_3 = 'type_3',
}

export const errorResponse = {
  status: 400,
  message: 'Something went wrong please try again after sometime.',
  data: '',
};
export const invalidFileError = {
  status: 400,
  message: 'Uploaded file is invalid. Please refer the template.',
  data: '',
};
export const DATE_RANGE = {
  THREE_MONTHS: '90',
  SIX_MONTHS: '180',
  ONE_YEAR: '365',
  BY_DATE: 'byDate',
};

export const TOPLINE_AUTO_SUGGESTIONS_WHAT: any = [
  // "What was the Dollar share of <category> in the latest 4 week for <channel/retailer> ?",
  // "List the top 3 retailers with highest Dollar share of <category> for lastest 4 weeks",
  // "Who are the brands gaining share in <category>, for latest 4 weeks? Sort in Desc order",
  // "Who are the other key competitors losing notable share in <category1> and <category2>, for latest 4 weeks ?",
  // "Who are top 10 performing brands of <category> by  Dollar Share for latest 4 weeks? Include Dollar share change to the result",
  // "What are the regions losing share in <category> in the latest 4 weeks?",
  // "Who are the key competitors gaining share in <category>, for latest 4 weeks?",
  // "Which channel had the highest dollar share in the lastest 4 weeks for <category> ?",
  // "Which region shows the highest and lowest growth in Dollar sale in lastest 4 weeks compared to last year for  <category>?",
  // "What was the dollar share of <category> in the latest 1 week, latest 4 week, QTD and YTD for muloc+? create a bar graph representation of the result",

  // 'What was the Dollar share of <category/s> in the <Time dimension/s> for < channels/retailers> ?',
  // 'What was share change of <category/s> in <Time dimension/s> for <region>?',
  // 'Which channel has the highest dollar share in <Time dimension/s>  for <category/s>?',
  // 'Which region shows the highest and lowest growth in Dollar sale in < Time dimension> compared to last year for  <category>?',
  // 'Who are top 10 performing brands of <category/s> by  Dollar Share for <Time dimension/s>?',
  // 'Who are our top-performing brands of <category/s> by Dollar share for <Time Dimension/s>? Include Dollar share change to the result',
  // 'Who are the other key competitors losing notable share in <category/s>, for <Time Dimension/s> ?',
  // 'List the regions with the highest dollar sales in the <Time Dimension/s> for <category/s>',
  // 'What does <category> sales growth performance look like for <channels> over the <Time Dimension>?',
  // 'List the top retailers gaining Dollar share in <category> for <Time Dimension/s>',
  // 'Are there any underperforming trademarks in <category> by Dollar Share this <Time Dimension/s>? Include flat share trademarks to the above result',
  // 'List top 3 and bottom 3 manufacturers by  Dollar share change of <Category> in the <Time Dimension/s> ?',
  // 'what was the rank of <region> in < Time Dimension/s>',
  // 'How was performance of <Competitor/s> compared to Pepsico for <category> in <Time Dimension/s>',
  // "Which channel apart from muloc+ has highest Frito-Lay's savory dollar share in the <Time Dimension>?",
  // 'What FL Region had the most challenged dollar share performance in <Time Dimension>?',
  // 'What was the rank in sales of the < region> in < Time Dimension/s>',
  // 'What was the dollar share of <category> in the latest 1 week, latest 4 week, QTD and YTD for muloc+? create a bar graph representation of the result',
  // 'What are the regions losing share in <category> in <Time Dimension>?',
  // 'Who are the brands gaining share in <category>, for < Time Dimension>?  Sort in Desc order',
  'What was the dollar share of savory in the latest 1 week, latest 4 week for muloc+?',
  'Who are the other key competitors losing notable share in salty  YTD?',
  'Who are top 10 performing brands of salty by  Dollar Share in latest 4 weeks? ',
  'Which channel has the highest dollar share in salty , savory QTD?',
  'Which retailers have gained the most dollar share in savory YTD?',
  'Which regions recorded the highest dollar sales in salty during the latest 4 weeks?',
  'How did Kellanova perform compared to PepsiCo in savory during the latest 4 weeks?',
  'List the top 3 and bottom 3 manufacturers by dollar share change in salty for the latest  4 weeks',
  "Which channel outside of muloc+ drove the highest Frito-Lay's savory dollar share in the latest 4 weeks?",
  'Which regions lost dollar share in savory during the latest 4 weeks?',
  'Which brands gained share in savory during the latest 4 weeks? Sort in Desc order',
  'What was the dollar share of salty in grocery in the latest 1 week?',
  'What was the year-to-date share change of salty in the Atlantic region?',
  'List the top-performing salty brands by YTD dollar share . Include Dollar share change to the result',
  'What does salty sales growth look like in drugs during the latest 4 weeks?',
  'Which trademarks in savory are underperforming by dollar share year-to-date? Include flat share trademarks to the above result?',
  'what was the rank of Southeast in latest 4 weeks?',
  'Which FL region had the most challenged dollar share perfromance this quarter?',
  'What was the sales rank of the Atlantic region year-to-date?',
];

export const TOPLINE_AUTO_SUGGESTIONS_WHAT_UAE_MT: any = [
  // 'What are the <Brands> which are contributing most to my <sub-category> revenue growth in <last 4 weeks>',
  // 'Who are the <Retailers> for which my category share has declined wrto competitor in <last 4 weeks>',
  // 'Which format is performing best in the <city> and which are the <pack types> are successful in those formats',
  // 'Who are the other key competitor in <sub-category> gaining revenue share and what are the <brands> contributing to that',
  'What is Pepsico YTD overall market share?',
  'What was Pepsico share in Potato Chips sub-category last quarter?',
  'Which retailer in Abu Dhabi gained the most share last month vs PAGO?',
  'Which account helped us gain share this year vs last year?',
  'Which brand gained the most share last month as compared to previous month?',
  'Which competitor brand lost the most share MTD vs PAGO?',
  'Which of our SKUs gained the most share this year vs same period last year?',
  'What is our YTD overall market share?',
  'Which retailers lost share in Q1 vs PAGO?',
  'Which outlets lost share last month compared to previous month?',
  'Compare our market share across regions YTD.'
];

export const R_AND_D_AUTO_SUGGESTIONS: any = [
  'Any sectors where the AIBI scores are improved ?',
  'Which plants are getting worse scores ?',
  'Which plants have repeat unsatisfactory findings ? The same finding across multiple audits.',
  'Which requirement has the most unsatisfactory findings ?',
  'Which country has the best performing plants ?',
];

export const CONTENT_REGEX = /content="\[(.*?)]/g;
export const CONTENT_REGEX_TWO = /content='\[(.*?)]/g;

export const restrictedUsers = ['test@gmail.com'];

interface VariationData {
  [key: string]: string[];
}

export const variationData: VariationData = {
  'Variation 1': [
    'Workflow Orchestrator getting things started.....',
    'Capturing your question.....',
    'Gathering the right agents.....',
    'Query Analyzer Agent standing by.....',
    'Query Analyzer clarifies what you need.....',
    'Supervisor Agent reviewing our plan.....',
    'Supervisor gives the go-ahead.....',
    'Text-to-SQL Agent stepping in.....',
    'Text-to-SQL turns the ask into a data request.....',
    'Connecting to our trusted data source.....',
    'Fetching the numbers.....',
    'Bringing the data back.....',
    'Analyst Agent gives the figures a once-over.....',
    'Analyst calculates key numbers.....',
    'Analyst spotlights the big takeaways.....',
    'Response Synthesizer Agent joins the mix.....',
    'Synthesizer shapes the story.....',
    'Delivering insights to your screen.....',
    // 'All set—ready for your next question.....',
  ],
  'Variation 2': [
    'Workflow Orchestrator setting the stage.....',
    'Calling in Query Analyzer Agent.....',
    'Query Analyzer pinpoints your request.....',
    'Supervisor Agent double-checks the details.....',
    'Supervisor gives the thumbs-up.....',
    'Text-to-SQL Agent on deck.....',
    'Crafting a smart data request.....',
    'Linking to the data hub.....',
    'Gathering the numbers.....',
    'Data is in hand.....',
    'Analyst Agent organizes the results.....',
    'Analyst sums up key metrics.....',
    'Analyst extracts business insights.....',
    'Response Synthesizer Agent writes the story.....',
    'Polishing the answer.....',
    'Sending results to your screen.....',
    'Showing insights now.....',
    // "Standing by for what's next.....",
  ],
  'Variation 3': [
    'Workflow Orchestrator is live.....',
    'Logging your question.....',
    'Activating Query Analyzer Agent.....',
    'Query Analyzer breaks down what you need.....',
    'Supervisor Agent confirms the path.....',
    'Supervisor waves us forward.....',
    'Text-to-SQL Agent starts working.....',
    'Turning your ask into a data pull.....',
    'Connecting to the data source.....',
    'Collecting the figures.....',
    'Analyst Agent reviews and interprets.....',
    'Response Synthesizer Agent drafts the answer.....',
    'Insights heading your way.....',
    // 'Done—ready when you are.',
  ],
  'Variation 4': [
    'Workflow Orchestrator online and ready.....',
    'Opening a new session.....',
    'Query Analyzer Agent reviews your ask.....',
    'Supervisor Agent checks the details.....',
    'Supervisor approves; calling Text-to-SQL Agent.....',
    'Text-to-SQL creates the data request.....',
    'Connecting to our data bank.....',
    'Pulling the latest numbers.....',
    'Analyst Agent looks over the data.....',
    'Analyst spots trends and patterns.....',
    'Response Synthesizer Agent crafts the message.....',
    'Synthesizer makes it easy to read.....',
    'Packaging the final answer.....',
    'Sending results your way.....',
    // 'Answer displayed.....',
    // 'Reset—ready for the next question.....',
  ],
};

interface FilterGroup {
  [optionKey: string]: any;
}

interface FilterOptions {
  [category: string]: FilterGroup;
}

export const filterOptions: FilterOptions = {
  // Comparison: {
  //   MTDvsYAGO: 'MTD_YAGO',
  //   MTDvsPAGO: 'MTD_PAGO',
  //   YTD: 'YTD',
  //   // MAT: 'MAT',
  // },
  // Year: {
  //   '2025': 2025,
  //   '2024': 2024,
  //   '2023': 2023,
  // },
  // Month: {
  //   January: 1,
  //   February: 2,
  //   March: 3,
  //   April: 4,
  //   May: 5,
  //   June: 6,
  //   July: 7,
  //   August: 8,
  //   September: 9,
  //   October: 10,
  //   November: 11,
  //   December: 12,
  // },
  Region: {},
  "Sub Region": {},
  Retailer: {},
  City: {},

  // 'Product Universe': {
  //   ALL: 'ALL',
  //   PEPSICO: 'PEPSICO',
  //   SSFL: 'SSFL',
  //   'COMPETITION 1': 'COMPETITION 1',
  //   'COMPETITION 2': 'COMPETITION 2',
  // },
  // Manufacturer: {},
  'Sub Category': {
    ALL: 'All',
    'POTATO CHIPS': 'Potato Chips',
    TORTILLA: 'Tortilla',
    EXTRUDED: 'Extruded',
    // 'Multigrain/Snack Mix': 'Multigrain/Snack Mix',
  },

  // Brand: {},

  // "Insights Type": {
  //   "Hierarchial": "Hierarchial",
  //   "Comrehensive": "Comrehensive",
  // },
  // KPI: {
  //   Revenue: 'Revenue',
  //   Transaction: 'Transaction',
  //   Volume: 'Volume',
  // },
  // 'Use Cache':{
  // TRUE:'true',
  // FALSE:'false',
  // },
};

export const UAEMTUsers = [
  "vishal.kumar2@pepsico.com",
  "naveenkumar.bobbadi@pepsico.com",
  "raghavendra.pr@pepsico.com",
  "hruday.vinayak.contractor@pepsico.com",
  "rajendra.jain@pepsico.com",
  "monika.sharma1@pepsico.com",
  "rucha.pattnaik.contractor@pepsico.com",
  "alex.mansur@pepsico.com",
  "raziya.salma@pepsico.com",
  "amit.gupta@pepsico.com",
  "vaibhav.sharma2.contractor@pepsico.com",
  "pankaj.gupta01@pepsico.com",
  "amit.sinha@pepsico.com",
  "avirup.auddy@pepsico.com",
  "utkarsh.saxena.contractor@pepsico.com",
  "seemant.singh.contractor@pepsico.com",
  "vinay.pal.contractor@pepsico.com",
  "prateek.tiwari.contractor@pepsico.com",
  "srinivas.mule.contractor@pepsico.com",
  "maharsha.nakkella.contractor@pepsico.com",
  "muhammad.uzair@pepsico.com",
  "himanshu.singh2.contractor@pepsico.com",
  "ronojoy.kumar.contractor@pepsico.com",
  "tanmay.jain@pepsico.com",
  "hruday.vinayak@pepsico.com",
  "hariprasath.srinivasan.contractor@pepsico.com",
  "saikrishna.muppa.contractor@pepsico.com",
  "divya.sherikari@pepsico.com",
  "tishyo.bhowmik.contractor@pepsico.com",
  "utkarsh.saxena1.contractor@pepsico.com",
];

export const ConfigUsers = [
  "shriram.kharat.contractor@pepsico.com",
  "ashwani.singh1@pepsico.com",
  "raziya.salma@pepsico.com",
  "dhruv.devani@pepsico.com",
  "mohdAslam.khan.contractor@pepsico.com",
  "hruday.vinayak@pepsico.com",
  "anupam.debnath@pepsico.com",
];
